export const MONSTERS = {
    mire_rat: {
        id: 'mire_rat',
        name: 'Mire-Rat',
        zone: 'The Murkwarrens',
        level: 2,
        hp: 8,
        xp: 8,
        maxHit: 1,
        swingSpeedSeconds: 2.4,
        minCoins: 1,
        maxCoins: 2,
        guaranteedDropItemId: 'mire_rat_pelt',
        rareDrop: { itemId: 'gnawed_talisman', chance: 1 / 2500 },
    },
    stone_carapace: {
        id: 'stone_carapace',
        name: 'Stone Carapace',
        zone: 'Cragridge',
        level: 3,
        hp: 10,
        xp: 11,
        maxHit: 1,
        swingSpeedSeconds: 2.4,
        minCoins: 1,
        maxCoins: 2,
        guaranteedDropItemId: 'mire_rat_pelt',
        rareDrop: { itemId: 'gnawed_talisman', chance: 1 / 2500 },
    },
    fen_creeper: {
        id: 'fen_creeper',
        name: 'Fen Creeper',
        zone: 'Dread Marsh',
        level: 5,
        hp: 13,
        xp: 15,
        maxHit: 2,
        swingSpeedSeconds: 2.4,
        minCoins: 1,
        maxCoins: 2,
        guaranteedDropItemId: 'mire_rat_pelt',
        rareDrop: { itemId: 'gnawed_talisman', chance: 1 / 2000 },
    },
    mire_ghoul: {
        id: 'mire_ghoul',
        name: 'Mire Ghoul',
        zone: 'Blackbog',
        level: 8,
        hp: 18,
        xp: 22,
        maxHit: 3,
        swingSpeedSeconds: 2.4,
        minCoins: 2,
        maxCoins: 4,
        guaranteedDropItemId: 'ghoul_hide',
        rareDrop: { itemId: 'bog_pearl', chance: 1 / 1667 },
    },
    carrion_scarab: {
        id: 'carrion_scarab',
        name: 'Carrion Scarab',
        zone: 'Crypt Fields',
        level: 12,
        hp: 26,
        xp: 34,
        maxHit: 4,
        swingSpeedSeconds: 2.4,
        minCoins: 4,
        maxCoins: 9,
        guaranteedDropItemId: 'crypt_carapace',
        rareDrop: { itemId: 'dry_sigil', chance: 1 / 1667 },
        keyDrop: { itemId: 'item_crypt_key', chance: 1 / 100 },
    },
    trench_skulker: {
        id: 'trench_skulker',
        name: 'Trench Skulker',
        zone: 'Sunken Grotto',
        level: 16,
        hp: 33,
        xp: 46,
        maxHit: 5,
        swingSpeedSeconds: 2.4,
        minCoins: 9,
        maxCoins: 18,
        guaranteedDropItemId: 'ghoul_hide',
        rareDrop: { itemId: 'bog_pearl', chance: 1 / 1429 },
    },
    dust_revenant: {
        id: 'dust_revenant',
        name: 'Dust Revenant',
        zone: 'Desolate Barrow',
        level: 20,
        hp: 40,
        xp: 60,
        maxHit: 6,
        swingSpeedSeconds: 2.4,
        minCoins: 17,
        maxCoins: 32,
        guaranteedDropItemId: 'crypt_carapace',
        rareDrop: { itemId: 'dry_sigil', chance: 1 / 1250 },
        keyDrop: { itemId: 'item_crypt_key', chance: 1 / 60 },
    },
    lithophage: {
        id: 'lithophage',
        name: 'Lithophage',
        zone: 'Gorgon Gorge',
        level: 22,
        hp: 44,
        xp: 70,
        maxHit: 6,
        swingSpeedSeconds: 2.4,
        minCoins: 22,
        maxCoins: 41,
        guaranteedDropItemId: 'crypt_carapace',
        rareDrop: { itemId: 'dry_sigil', chance: 1 / 1250 },
    },
    grim_hound: {
        id: 'grim_hound',
        name: 'Grim Hound',
        zone: 'Shadowed Barrow',
        level: 26,
        hp: 51,
        xp: 91,
        maxHit: 7,
        swingSpeedSeconds: 2.4,
        minCoins: 35,
        maxCoins: 65,
        guaranteedDropItemId: 'crypt_carapace',
        rareDrop: { itemId: 'dry_sigil', chance: 1 / 1111 },
        keyDrop: { itemId: 'item_crypt_key', chance: 1 / 45 },
    },
    marble_wight: {
        id: 'marble_wight',
        name: 'Marble Wight',
        zone: 'Pale Terraces',
        level: 32,
        hp: 61,
        xp: 122,
        maxHit: 8,
        swingSpeedSeconds: 2.4,
        minCoins: 62,
        maxCoins: 116,
        guaranteedDropItemId: 'crypt_carapace',
        rareDrop: { itemId: 'dry_sigil', chance: 1 / 1000 },
        keyDrop: { itemId: 'item_crypt_key', chance: 1 / 35 },
    },
    barrow_wight: {
        id: 'barrow_wight',
        name: 'Barrow Wight',
        zone: 'Ancestral Cairns',
        level: 40,
        hp: 75,
        xp: 165,
        maxHit: 10,
        swingSpeedSeconds: 2.4,
        minCoins: 117,
        maxCoins: 217,
        guaranteedDropItemId: 'ossuary_bone',
        rareDrop: { itemId: 'cairn_sigil', chance: 1 / 1000 },
    },
    dune_spectre: {
        id: 'dune_spectre',
        name: 'Dune Spectre',
        zone: 'Scorched Waste',
        level: 50,
        hp: 95,
        xp: 250,
        maxHit: 12,
        swingSpeedSeconds: 2.4,
        minCoins: 220,
        maxCoins: 409,
        guaranteedDropItemId: 'spectre_ash',
        rareDrop: { itemId: 'solar_remnant', chance: 1 / 833 },
    },
    frost_worg: {
        id: 'frost_worg',
        name: 'Frost-Worg',
        zone: 'Glacial Expanse',
        level: 60,
        hp: 120,
        xp: 380,
        maxHit: 15,
        swingSpeedSeconds: 2.4,
        minCoins: 369,
        maxCoins: 685,
        guaranteedDropItemId: 'frost_worg_fur',
        rareDrop: { itemId: 'rimefang', chance: 1 / 714 },
    },
    mirage_stalker: {
        id: 'mirage_stalker',
        name: 'Mirage Stalker',
        zone: 'Vitrified Sands',
        level: 70,
        hp: 150,
        xp: 550,
        maxHit: 18,
        swingSpeedSeconds: 2.4,
        minCoins: 572,
        maxCoins: 1063,
        guaranteedDropItemId: 'dreadclaw',
        rareDrop: { itemId: 'venomfang', chance: 1 / 625 },
    },
    flameborn_fiend: {
        id: 'flameborn_fiend',
        name: 'Flameborn Fiend',
        zone: 'Cinder Caldera',
        level: 80,
        hp: 180,
        xp: 780,
        maxHit: 22,
        swingSpeedSeconds: 3.0,
        minCoins: 837,
        maxCoins: 1554,
        guaranteedDropItemId: 'ember_scale',
        rareDrop: { itemId: 'cinder_core', chance: 1 / 500 },
    },
    glacial_jarl: {
        id: 'glacial_jarl',
        name: 'Glacial Jarl',
        zone: 'Frostpeak Ridge',
        level: 85,
        hp: 210,
        xp: 1000,
        maxHit: 25,
        swingSpeedSeconds: 3.0,
        minCoins: 994,
        maxCoins: 1847,
        guaranteedDropItemId: 'jarls_hide',
        rareDrop: { itemId: 'frost_tusk', chance: 1 / 455 },
    },
    void_eldritch: {
        id: 'void_eldritch',
        name: 'Void Eldritch',
        zone: 'Abyssal Trench',
        level: 95,
        hp: 260,
        xp: 1500,
        maxHit: 30,
        swingSpeedSeconds: 3.0,
        minCoins: 1365,
        maxCoins: 2535,
        guaranteedDropItemId: 'void_ichor',
        rareDrop: { itemId: 'gazing_eye', chance: 1 / 333 },
    },
    frost_monarch: {
        id: 'frost_monarch',
        name: 'Frost Monarch',
        zone: 'Permafrost Spire',
        level: 105,
        hp: 300,
        xp: 2000,
        maxHit: 34,
        swingSpeedSeconds: 3.0,
        minCoins: 1815,
        maxCoins: 3371,
        guaranteedDropItemId: 'rime_shard',
        rareDrop: { itemId: 'glacial_crown', chance: 1 / 333 },
    },
    ashen_drake: {
        id: 'ashen_drake',
        name: 'Ashen Drake',
        zone: 'Wyrmcrag',
        level: 120,
        hp: 360,
        xp: 2800,
        maxHit: 40,
        swingSpeedSeconds: 3.0,
        minCoins: 2655,
        maxCoins: 4932,
        guaranteedDropItemId: 'drake_leather',
        rareDrop: { itemId: 'draconic_scale', chance: 1 / 286 },
    },
    magma_titan: {
        id: 'magma_titan',
        name: 'Magma Titan',
        zone: 'Obsidian Spire',
        level: 140,
        hp: 440,
        xp: 4000,
        maxHit: 48,
        swingSpeedSeconds: 3.6,
        minCoins: 4120,
        maxCoins: 7651,
        guaranteedDropItemId: 'titan_shard',
        rareDrop: { itemId: 'primordial_ember', chance: 1 / 250 },
    },
    crypt_lord: {
        id: 'crypt_lord',
        name: 'The Crypt Lord',
        zone: 'The Whispering Crypt',
        level: 30,
        hp: 220,
        xp: 650,
        maxHit: 12,
        swingSpeedSeconds: 2.8,
        minCoins: 0,
        maxCoins: 0,
    },
};
export const WORLD_BOSSES = {
    earth_titan: {
        id: 'earth_titan',
        name: 'The Earth Titan',
        styleWeakness: 'melee',
        baseHp: 50000,
        uniqueCoreItemId: 'titan_core',
    },
    glacial_leviathan: {
        id: 'glacial_leviathan',
        name: 'The Glacial Leviathan',
        styleWeakness: 'ranged',
        baseHp: 50000,
        uniqueCoreItemId: 'leviathan_scale',
    },
    pyro_wyrm: {
        id: 'pyro_wyrm',
        name: 'The Pyro-Wyrm',
        styleWeakness: 'magic',
        baseHp: 50000,
        uniqueCoreItemId: 'wyrm_ember',
    },
};
//# sourceMappingURL=monsters.js.map